import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
import { Link, Route } from 'react-router-dom';

import LazyImage from '../components/LazyImage';
import ProductItem from '../components/ProductItem';
import Progress from '../components/Progress';
import Video from '../components/Video';

import { Layout } from '.';

@inject('ProductStore') @observer
export default class Product extends Component {
	componentWillMount() {
		const { ProductStore } = this.props;
		const { params } = this.props.match;
		ProductStore.loadProduct(params.product_slug);
	}

	componentWillUnmount() {
		const { ProductStore } = this.props;
		ProductStore.setSection(null);
	}

	componentWillReceiveProps(nextProps) {
		const { params } = nextProps.match;
		const { ProductStore } = this.props;
		if (!ProductStore.selectedProduct || (params.product_slug !== ProductStore.selectedProduct.slug)) {
			ProductStore.loadProduct(params.product_slug);
			window.scrollTo(0,0);
		}
		return true;
	}

	render() {
		const { ProductStore } = this.props;
		return (
			<Layout footerStyle={{backgroundColor: '#FFF'}}>
				<div id="interna-produto">
					{ProductStore.selectedProduct &&
						(
							<div>
								<Route path={`${this.props.match.url}/itens/:id`} component={ProductItem} onChange={(prevState, nextState) => {
			            if (nextState.location.action !== "POP") {
			              window.scrollTo(0, 0);
			            }
			          }}/>
								<Route path={`${this.props.match.url}/video`} render={() => {
										return <Video history={this.props.history} title={ProductStore.selectedProduct.name} videoId={ProductStore.selectedProduct.video} />
									}} />
							</div>
						)
					}

					{ ProductStore.sectionsIsLoaded && !ProductStore.selectedProduct && <div className="relative"><Progress/></div> }

					{ ProductStore.selectedProduct &&
						(
							<section className="container-content-banner">
								<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMAAAAA4CAMAAACcwwdBAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAACBJREFUaN7twQEBAAAAgiD/r25IQAEAAAAAAAAAAADwYCo4AAGTOdYnAAAAAElFTkSuQmCC" alt="" className="transparent-img"/>

								<LazyImage
			            className="banner"
			            alt=""
			            src={ProductStore.selectedProduct.section.banner}
			            low={ProductStore.selectedProduct.section.banner} />

								<section className="container-main">
									<section className="main">
										<h1>{ProductStore.selectedProduct.name}</h1>

										<div className="container-internal-header-menu">
											{ ProductStore.selectedProduct.video &&
												(
													<ul className="internal-header-menu">
														<li className="video-button">
															<Link to={`${this.props.match.url}/video`} title="Vídeo sobre o produto">
																<img src={require('../img/icon-play-button.svg')} alt="" className="icon-plus"/>
																<img src={require('../img/icon-play-button-green.svg')} alt="" className="icon-plus-white"/>
																<span>Vídeo sobre o produto</span>
															</Link>
														</li>
													</ul>
												)
											}

											<ul className="internal-header-menu">
											{ ProductStore.selectedProduct.product_contents.map(content => {
												return (
														<li key={content.id}>
															<Link onClick={() => window.scrollTo(0, 0)} to={`${this.props.match.url}/itens/${content.category.id}`} title={content.category.name}>
																<img src={require('../img/icon-plus.svg')} alt="" className="icon-plus"/>
																<img src={require('../img/icon-plus-white.svg')} alt="" className="icon-plus-white"/>
																<span>{content.category.name}</span>
															</Link>
														</li>
												)
											})}
											</ul>
										</div>
									</section>
								</section>
							</section>
						)
					}

					{ ProductStore.selectedProduct && ProductStore.selectedSection && ProductStore.relatedProducts.length > 0 &&
						(
							<div>
								<section className="main">
									<div className="related-products-container">
										<h2>Outros produtos de <span>{ProductStore.selectedSection.name}</span></h2>

										<ul className="related-products">
											{ ProductStore.relatedProducts.map(product => {
												return (
													<li key={product.id}>
														<Link to={`/p/${ProductStore.selectedSection.slug}/${product.slug}`} title={product.name} className="generic-link-segment">
															<div>
																
																<img src={product.icon} />
															</div>

															<span>{product.name}</span>
														</Link>
													</li>
												)
											})}
										</ul>
									</div>
								</section>
							</div>
						)
					}

				</div>
			</Layout>
		);
	}
}



// WEBPACK FOOTER //
// ./src/screens/Product.js